import { render } from "./AddMonnaiePage.vue?vue&type=template&id=d436c0ea&ts=true"
import script from "./AddMonnaiePage.vue?vue&type=script&lang=ts"
export * from "./AddMonnaiePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__